import { Box, Button, Card, Grid, Typography, styled } from "@mui/material";

export const RootStyle = styled(Box)(({ theme }) => ({
  background: "#ffffff",
  padding: "72px 83px",
  [theme.breakpoints.down("md")]: {
    padding: "30px 15px",
  },
}));

export const Title = styled(Typography)(({ theme }) => ({
  fontFamily: "Poppins",
  fontWeight: 700,
  fontSize: "40px",
  color: "#4CAF50",
  [theme.breakpoints.down("md")]: {
    fontSize: "30px",
    textAlign: "center",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "20px",
    textAlign: "center",
  },
}));
export const SubTitle = styled(Typography)(({ theme }) => ({
  fontFamily: "Poppins",
  fontWeight: 500,
  fontSize: "24px",
  color: "#60656C",
  [theme.breakpoints.down("md")]: {
    fontSize: "20px",
    textAlign: "center",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "16px",
    textAlign: "center",
  },
}));
export const Text = styled(Typography)(({ theme }) => ({
  fontFamily: "Poppins",
  fontWeight: 400,
  fontSize: "18px",
  color: "#60656C",
  [theme.breakpoints.down("md")]: {
    fontSize: "16px",
    textAlign: "center",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
    textAlign: "center",
  },
}));
export const AboutText = styled(Typography)(({ theme }) => ({
  fontFamily: "Poppins",
  fontWeight: 600,
  fontSize: "20px",
  color: "#60656C",
  lineHeight: "30px",
  [theme.breakpoints.down("md")]: {
    fontSize: "16px",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
  },
}));

export const CustomCard = styled(Card)({
  border: "none !important",
  background: "transparent",
  boxShadow: "none",
});

export const HoverBox = styled(Box)({
  borderBottom: "2px solid #4CAF50",
  borderRadius: "16px",
  minHeight: "400px",
  padding: "0 16px",
  background: "#FAFAFA",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
});

export const CardBox = styled(Box)({
  borderBottom: "2px solid #4CAF50",
  borderRadius: "16px",
  minHeight: "400px",
  padding: "0 16px",
  background: "#FAFAFA",
});

export const BlueBox = styled(Box)(({ theme }) => ({
  background: "#4DAF51",
  borderRadius: "24px",
  // minHeight: "290px",
  padding: "16px",
  display: "flex",
  [theme.breakpoints.down("md")]: {
    background: "transparent",
  },
}));
export const InnerBlueBox = styled(Box)(({ theme }) => ({
  background: "#FAFAFA29",
  borderRadius: "24px",
  // minHeight: "290px",
  padding: "16px",
  display: "flex",
  flex: "1",
  [theme.breakpoints.down("md")]: {
    background: "transparent",
    // background: "transparent",
  },
}));

export const BtnAccess = styled(Button)(({ theme }) => ({
  fontFamily: "Poppins",
  fontWeight: 600,
  fontSize: "20px",
  textTransform: "none",
  color: "#4CAF50",
  background: "#fff",
  padding: "10px 56px",
  [theme.breakpoints.down("md")]: {
    fontSize: "18px",
    marginTop: "40px",
    color: "#fff",
    background: "#4CAF50",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "16px",
    padding: "10px 16px",
  },
}));

export const InfoItemBox = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  rowGap: "16px",
});

export const AboutTitle = styled(Typography)(({ theme }) => ({
  fontFamily: "Poppins",
  fontWeight: 600,
  fontSize: "32px",
  color: "#FFFFFF",
  [theme.breakpoints.down("md")]: {
    fontSize: "24px",
    textAlign: "center",
    color: "#4CAF50",
  },
  [theme.breakpoints.down("sm")]: {
    color: "#4CAF50",
    fontSize: "18px",
    textAlign: "center",
  },
}));
export const AboutGrid = styled(Grid)(({ theme }) => ({
  display: "flex",
  order: 1,
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "space-evenly",
  [theme.breakpoints.down("md")]: {
    alignItems: "center",
    order: 2,
    fontSize: "24px",
    textAlign: "center",
    color: "#4CAF50",
  },
  [theme.breakpoints.down("sm")]: {
    color: "#4CAF50",
    fontSize: "18px",
  },
}));
export const ReviewBox = styled(Box)(({ theme }) => ({
  background:
    "linear-gradient(90deg, #439B46 0%, #4CAF50 48.96%, #439B46 100%)",
  padding: "40px",
  borderRadius: "24px",
}));
